// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    v2PublicGetReferenceCurrencies (params?: {}): Promise<Dict>;
    v2PublicGetMarketStatus (params?: {}): Promise<Dict>;
    v2PrivateGetAccountLedger (params?: {}): Promise<Dict>;
    v2PrivateGetAccountWithdrawQuota (params?: {}): Promise<Dict>;
    v2PrivateGetAccountWithdrawAddress (params?: {}): Promise<Dict>;
    v2PrivateGetAccountDepositAddress (params?: {}): Promise<Dict>;
    v2PrivateGetAccountRepayment (params?: {}): Promise<Dict>;
    v2PrivateGetReferenceTransactFeeRate (params?: {}): Promise<Dict>;
    v2PrivateGetAccountAssetValuation (params?: {}): Promise<Dict>;
    v2PrivateGetPointAccount (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserUserList (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserUserState (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserAccountList (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserDepositAddress (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserQueryDeposit (params?: {}): Promise<Dict>;
    v2PrivateGetUserApiKey (params?: {}): Promise<Dict>;
    v2PrivateGetUserUid (params?: {}): Promise<Dict>;
    v2PrivateGetAlgoOrdersOpening (params?: {}): Promise<Dict>;
    v2PrivateGetAlgoOrdersHistory (params?: {}): Promise<Dict>;
    v2PrivateGetAlgoOrdersSpecific (params?: {}): Promise<Dict>;
    v2PrivateGetC2cOffers (params?: {}): Promise<Dict>;
    v2PrivateGetC2cOffer (params?: {}): Promise<Dict>;
    v2PrivateGetC2cTransactions (params?: {}): Promise<Dict>;
    v2PrivateGetC2cRepayment (params?: {}): Promise<Dict>;
    v2PrivateGetC2cAccount (params?: {}): Promise<Dict>;
    v2PrivateGetEtpReference (params?: {}): Promise<Dict>;
    v2PrivateGetEtpTransactions (params?: {}): Promise<Dict>;
    v2PrivateGetEtpTransaction (params?: {}): Promise<Dict>;
    v2PrivateGetEtpRebalance (params?: {}): Promise<Dict>;
    v2PrivateGetEtpLimit (params?: {}): Promise<Dict>;
    v2PrivatePostAccountTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostAccountRepayment (params?: {}): Promise<Dict>;
    v2PrivatePostPointTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserManagement (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserCreation (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserTradableMarket (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserTransferability (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserApiKeyGeneration (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserApiKeyModification (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserApiKeyDeletion (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserDeductMode (params?: {}): Promise<Dict>;
    v2PrivatePostAlgoOrders (params?: {}): Promise<Dict>;
    v2PrivatePostAlgoOrdersCancelAllAfter (params?: {}): Promise<Dict>;
    v2PrivatePostAlgoOrdersCancellation (params?: {}): Promise<Dict>;
    v2PrivatePostC2cOffer (params?: {}): Promise<Dict>;
    v2PrivatePostC2cCancellation (params?: {}): Promise<Dict>;
    v2PrivatePostC2cCancelAll (params?: {}): Promise<Dict>;
    v2PrivatePostC2cRepayment (params?: {}): Promise<Dict>;
    v2PrivatePostC2cTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostEtpCreation (params?: {}): Promise<Dict>;
    v2PrivatePostEtpRedemption (params?: {}): Promise<Dict>;
    v2PrivatePostEtpTransactIdCancel (params?: {}): Promise<Dict>;
    v2PrivatePostEtpBatchCancel (params?: {}): Promise<Dict>;
    publicGetCommonSymbols (params?: {}): Promise<Dict>;
    publicGetCommonCurrencys (params?: {}): Promise<Dict>;
    publicGetCommonTimestamp (params?: {}): Promise<Dict>;
    publicGetCommonExchange (params?: {}): Promise<Dict>;
    publicGetSettingsCurrencys (params?: {}): Promise<Dict>;
    privateGetAccountAccounts (params?: {}): Promise<Dict>;
    privateGetAccountAccountsIdBalance (params?: {}): Promise<Dict>;
    privateGetAccountAccountsSubUid (params?: {}): Promise<Dict>;
    privateGetAccountHistory (params?: {}): Promise<Dict>;
    privateGetCrossMarginLoanInfo (params?: {}): Promise<Dict>;
    privateGetMarginLoanInfo (params?: {}): Promise<Dict>;
    privateGetFeeFeeRateGet (params?: {}): Promise<Dict>;
    privateGetOrderOpenOrders (params?: {}): Promise<Dict>;
    privateGetOrderOrders (params?: {}): Promise<Dict>;
    privateGetOrderOrdersId (params?: {}): Promise<Dict>;
    privateGetOrderOrdersIdMatchresults (params?: {}): Promise<Dict>;
    privateGetOrderOrdersGetClientOrder (params?: {}): Promise<Dict>;
    privateGetOrderHistory (params?: {}): Promise<Dict>;
    privateGetOrderMatchresults (params?: {}): Promise<Dict>;
    privateGetQueryDepositWithdraw (params?: {}): Promise<Dict>;
    privateGetMarginLoanOrders (params?: {}): Promise<Dict>;
    privateGetMarginAccountsBalance (params?: {}): Promise<Dict>;
    privateGetCrossMarginLoanOrders (params?: {}): Promise<Dict>;
    privateGetCrossMarginAccountsBalance (params?: {}): Promise<Dict>;
    privateGetPointsActions (params?: {}): Promise<Dict>;
    privateGetPointsOrders (params?: {}): Promise<Dict>;
    privateGetSubuserAggregateBalance (params?: {}): Promise<Dict>;
    privateGetStableCoinExchangeRate (params?: {}): Promise<Dict>;
    privateGetStableCoinQuote (params?: {}): Promise<Dict>;
    privatePostAccountTransfer (params?: {}): Promise<Dict>;
    privatePostFuturesTransfer (params?: {}): Promise<Dict>;
    privatePostOrderBatchOrders (params?: {}): Promise<Dict>;
    privatePostOrderOrdersPlace (params?: {}): Promise<Dict>;
    privatePostOrderOrdersSubmitCancelClientOrder (params?: {}): Promise<Dict>;
    privatePostOrderOrdersBatchCancelOpenOrders (params?: {}): Promise<Dict>;
    privatePostOrderOrdersIdSubmitcancel (params?: {}): Promise<Dict>;
    privatePostOrderOrdersBatchcancel (params?: {}): Promise<Dict>;
    privatePostDwWithdrawApiCreate (params?: {}): Promise<Dict>;
    privatePostDwWithdrawVirtualIdCancel (params?: {}): Promise<Dict>;
    privatePostDwTransferInMargin (params?: {}): Promise<Dict>;
    privatePostDwTransferOutMargin (params?: {}): Promise<Dict>;
    privatePostMarginOrders (params?: {}): Promise<Dict>;
    privatePostMarginOrdersIdRepay (params?: {}): Promise<Dict>;
    privatePostCrossMarginTransferIn (params?: {}): Promise<Dict>;
    privatePostCrossMarginTransferOut (params?: {}): Promise<Dict>;
    privatePostCrossMarginOrders (params?: {}): Promise<Dict>;
    privatePostCrossMarginOrdersIdRepay (params?: {}): Promise<Dict>;
    privatePostStableCoinExchange (params?: {}): Promise<Dict>;
    privatePostSubuserTransfer (params?: {}): Promise<Dict>;
    spotPublicGetV2MarketStatus (params?: {}): Promise<Dict>;
    spotPublicGetV1CommonSymbols (params?: {}): Promise<Dict>;
    spotPublicGetV1CommonCurrencys (params?: {}): Promise<Dict>;
    spotPublicGetV2SettingsCommonCurrencies (params?: {}): Promise<Dict>;
    spotPublicGetV2ReferenceCurrencies (params?: {}): Promise<Dict>;
    spotPublicGetV1CommonTimestamp (params?: {}): Promise<Dict>;
    spotPublicGetV1CommonExchange (params?: {}): Promise<Dict>;
    spotPublicGetV1SettingsCommonChains (params?: {}): Promise<Dict>;
    spotPublicGetV1SettingsCommonCurrencys (params?: {}): Promise<Dict>;
    spotPublicGetV1SettingsCommonSymbols (params?: {}): Promise<Dict>;
    spotPublicGetV2SettingsCommonSymbols (params?: {}): Promise<Dict>;
    spotPublicGetV1SettingsCommonMarketSymbols (params?: {}): Promise<Dict>;
    spotPublicGetMarketHistoryCandles (params?: {}): Promise<Dict>;
    spotPublicGetMarketHistoryKline (params?: {}): Promise<Dict>;
    spotPublicGetMarketDetailMerged (params?: {}): Promise<Dict>;
    spotPublicGetMarketTickers (params?: {}): Promise<Dict>;
    spotPublicGetMarketDetail (params?: {}): Promise<Dict>;
    spotPublicGetMarketDepth (params?: {}): Promise<Dict>;
    spotPublicGetMarketTrade (params?: {}): Promise<Dict>;
    spotPublicGetMarketHistoryTrade (params?: {}): Promise<Dict>;
    spotPublicGetMarketEtp (params?: {}): Promise<Dict>;
    spotPublicGetV2EtpReference (params?: {}): Promise<Dict>;
    spotPublicGetV2EtpRebalance (params?: {}): Promise<Dict>;
    spotPrivateGetV1AccountAccounts (params?: {}): Promise<Dict>;
    spotPrivateGetV1AccountAccountsAccountIdBalance (params?: {}): Promise<Dict>;
    spotPrivateGetV2AccountValuation (params?: {}): Promise<Dict>;
    spotPrivateGetV2AccountAssetValuation (params?: {}): Promise<Dict>;
    spotPrivateGetV1AccountHistory (params?: {}): Promise<Dict>;
    spotPrivateGetV2AccountLedger (params?: {}): Promise<Dict>;
    spotPrivateGetV2PointAccount (params?: {}): Promise<Dict>;
    spotPrivateGetV2AccountDepositAddress (params?: {}): Promise<Dict>;
    spotPrivateGetV2AccountWithdrawQuota (params?: {}): Promise<Dict>;
    spotPrivateGetV2AccountWithdrawAddress (params?: {}): Promise<Dict>;
    spotPrivateGetV2ReferenceCurrencies (params?: {}): Promise<Dict>;
    spotPrivateGetV1QueryDepositWithdraw (params?: {}): Promise<Dict>;
    spotPrivateGetV1QueryWithdrawClientOrderId (params?: {}): Promise<Dict>;
    spotPrivateGetV2UserApiKey (params?: {}): Promise<Dict>;
    spotPrivateGetV2UserUid (params?: {}): Promise<Dict>;
    spotPrivateGetV2SubUserUserList (params?: {}): Promise<Dict>;
    spotPrivateGetV2SubUserUserState (params?: {}): Promise<Dict>;
    spotPrivateGetV2SubUserAccountList (params?: {}): Promise<Dict>;
    spotPrivateGetV2SubUserDepositAddress (params?: {}): Promise<Dict>;
    spotPrivateGetV2SubUserQueryDeposit (params?: {}): Promise<Dict>;
    spotPrivateGetV1SubuserAggregateBalance (params?: {}): Promise<Dict>;
    spotPrivateGetV1AccountAccountsSubUid (params?: {}): Promise<Dict>;
    spotPrivateGetV1OrderOpenOrders (params?: {}): Promise<Dict>;
    spotPrivateGetV1OrderOrdersOrderId (params?: {}): Promise<Dict>;
    spotPrivateGetV1OrderOrdersGetClientOrder (params?: {}): Promise<Dict>;
    spotPrivateGetV1OrderOrdersOrderIdMatchresult (params?: {}): Promise<Dict>;
    spotPrivateGetV1OrderOrdersOrderIdMatchresults (params?: {}): Promise<Dict>;
    spotPrivateGetV1OrderOrders (params?: {}): Promise<Dict>;
    spotPrivateGetV1OrderHistory (params?: {}): Promise<Dict>;
    spotPrivateGetV1OrderMatchresults (params?: {}): Promise<Dict>;
    spotPrivateGetV2ReferenceTransactFeeRate (params?: {}): Promise<Dict>;
    spotPrivateGetV2AlgoOrdersOpening (params?: {}): Promise<Dict>;
    spotPrivateGetV2AlgoOrdersHistory (params?: {}): Promise<Dict>;
    spotPrivateGetV2AlgoOrdersSpecific (params?: {}): Promise<Dict>;
    spotPrivateGetV1MarginLoanInfo (params?: {}): Promise<Dict>;
    spotPrivateGetV1MarginLoanOrders (params?: {}): Promise<Dict>;
    spotPrivateGetV1MarginAccountsBalance (params?: {}): Promise<Dict>;
    spotPrivateGetV1CrossMarginLoanInfo (params?: {}): Promise<Dict>;
    spotPrivateGetV1CrossMarginLoanOrders (params?: {}): Promise<Dict>;
    spotPrivateGetV1CrossMarginAccountsBalance (params?: {}): Promise<Dict>;
    spotPrivateGetV2AccountRepayment (params?: {}): Promise<Dict>;
    spotPrivateGetV5AccountUniversalTransferRecords (params?: {}): Promise<Dict>;
    spotPrivateGetV1StableCoinQuote (params?: {}): Promise<Dict>;
    spotPrivateGetV1StableCoinExchangeRate (params?: {}): Promise<Dict>;
    spotPrivateGetV2EtpTransactions (params?: {}): Promise<Dict>;
    spotPrivateGetV2EtpTransaction (params?: {}): Promise<Dict>;
    spotPrivateGetV2EtpLimit (params?: {}): Promise<Dict>;
    spotPrivatePostV1AccountTransfer (params?: {}): Promise<Dict>;
    spotPrivatePostV1FuturesTransfer (params?: {}): Promise<Dict>;
    spotPrivatePostV2PointTransfer (params?: {}): Promise<Dict>;
    spotPrivatePostV2AccountTransfer (params?: {}): Promise<Dict>;
    spotPrivatePostV1DwWithdrawApiCreate (params?: {}): Promise<Dict>;
    spotPrivatePostV1DwWithdrawVirtualWithdrawIdCancel (params?: {}): Promise<Dict>;
    spotPrivatePostV2SubUserDeductMode (params?: {}): Promise<Dict>;
    spotPrivatePostV2SubUserCreation (params?: {}): Promise<Dict>;
    spotPrivatePostV2SubUserManagement (params?: {}): Promise<Dict>;
    spotPrivatePostV2SubUserTradableMarket (params?: {}): Promise<Dict>;
    spotPrivatePostV2SubUserTransferability (params?: {}): Promise<Dict>;
    spotPrivatePostV2SubUserApiKeyGeneration (params?: {}): Promise<Dict>;
    spotPrivatePostV2SubUserApiKeyModification (params?: {}): Promise<Dict>;
    spotPrivatePostV2SubUserApiKeyDeletion (params?: {}): Promise<Dict>;
    spotPrivatePostV1SubuserTransfer (params?: {}): Promise<Dict>;
    spotPrivatePostV1TrustUserActiveCredit (params?: {}): Promise<Dict>;
    spotPrivatePostV1OrderOrdersPlace (params?: {}): Promise<Dict>;
    spotPrivatePostV1OrderBatchOrders (params?: {}): Promise<Dict>;
    spotPrivatePostV1OrderAutoPlace (params?: {}): Promise<Dict>;
    spotPrivatePostV1OrderOrdersOrderIdSubmitcancel (params?: {}): Promise<Dict>;
    spotPrivatePostV1OrderOrdersSubmitCancelClientOrder (params?: {}): Promise<Dict>;
    spotPrivatePostV1OrderOrdersBatchCancelOpenOrders (params?: {}): Promise<Dict>;
    spotPrivatePostV1OrderOrdersBatchcancel (params?: {}): Promise<Dict>;
    spotPrivatePostV2AlgoOrdersCancelAllAfter (params?: {}): Promise<Dict>;
    spotPrivatePostV2AlgoOrders (params?: {}): Promise<Dict>;
    spotPrivatePostV2AlgoOrdersCancellation (params?: {}): Promise<Dict>;
    spotPrivatePostV2AccountRepayment (params?: {}): Promise<Dict>;
    spotPrivatePostV1DwTransferInMargin (params?: {}): Promise<Dict>;
    spotPrivatePostV1DwTransferOutMargin (params?: {}): Promise<Dict>;
    spotPrivatePostV1MarginOrders (params?: {}): Promise<Dict>;
    spotPrivatePostV1MarginOrdersOrderIdRepay (params?: {}): Promise<Dict>;
    spotPrivatePostV1CrossMarginTransferIn (params?: {}): Promise<Dict>;
    spotPrivatePostV1CrossMarginTransferOut (params?: {}): Promise<Dict>;
    spotPrivatePostV1CrossMarginOrders (params?: {}): Promise<Dict>;
    spotPrivatePostV1CrossMarginOrdersOrderIdRepay (params?: {}): Promise<Dict>;
    spotPrivatePostV1StableCoinExchange (params?: {}): Promise<Dict>;
    spotPrivatePostV2EtpCreation (params?: {}): Promise<Dict>;
    spotPrivatePostV2EtpRedemption (params?: {}): Promise<Dict>;
    spotPrivatePostV2EtpTransactIdCancel (params?: {}): Promise<Dict>;
    spotPrivatePostV2EtpBatchCancel (params?: {}): Promise<Dict>;
    contractPublicGetApiV1Timestamp (params?: {}): Promise<Dict>;
    contractPublicGetHeartbeat (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractContractInfo (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractIndex (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractQueryElements (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractPriceLimit (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractOpenInterest (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractDeliveryPrice (params?: {}): Promise<Dict>;
    contractPublicGetMarketDepth (params?: {}): Promise<Dict>;
    contractPublicGetMarketBbo (params?: {}): Promise<Dict>;
    contractPublicGetMarketHistoryKline (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistoryMarkPriceKline (params?: {}): Promise<Dict>;
    contractPublicGetMarketDetailMerged (params?: {}): Promise<Dict>;
    contractPublicGetMarketDetailBatchMerged (params?: {}): Promise<Dict>;
    contractPublicGetV2MarketDetailBatchMerged (params?: {}): Promise<Dict>;
    contractPublicGetMarketTrade (params?: {}): Promise<Dict>;
    contractPublicGetMarketHistoryTrade (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractRiskInfo (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractInsuranceFund (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractAdjustfactor (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractHisOpenInterest (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractLadderMargin (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractApiState (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractEliteAccountRatio (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractElitePositionRatio (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractLiquidationOrders (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractSettlementRecords (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistoryIndex (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistoryBasis (params?: {}): Promise<Dict>;
    contractPublicGetApiV1ContractEstimatedSettlementPrice (params?: {}): Promise<Dict>;
    contractPublicGetApiV3ContractLiquidationOrders (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapContractInfo (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapIndex (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapQueryElements (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapPriceLimit (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapOpenInterest (params?: {}): Promise<Dict>;
    contractPublicGetSwapExMarketDepth (params?: {}): Promise<Dict>;
    contractPublicGetSwapExMarketBbo (params?: {}): Promise<Dict>;
    contractPublicGetSwapExMarketHistoryKline (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistorySwapMarkPriceKline (params?: {}): Promise<Dict>;
    contractPublicGetSwapExMarketDetailMerged (params?: {}): Promise<Dict>;
    contractPublicGetV2SwapExMarketDetailBatchMerged (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistorySwapPremiumIndexKline (params?: {}): Promise<Dict>;
    contractPublicGetSwapExMarketDetailBatchMerged (params?: {}): Promise<Dict>;
    contractPublicGetSwapExMarketTrade (params?: {}): Promise<Dict>;
    contractPublicGetSwapExMarketHistoryTrade (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapRiskInfo (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapInsuranceFund (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapAdjustfactor (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapHisOpenInterest (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapLadderMargin (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapApiState (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapEliteAccountRatio (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapElitePositionRatio (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapEstimatedSettlementPrice (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapLiquidationOrders (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapSettlementRecords (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapFundingRate (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapBatchFundingRate (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1SwapHistoricalFundingRate (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV3SwapLiquidationOrders (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistorySwapEstimatedRateKline (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistorySwapBasis (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapContractInfo (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapIndex (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapQueryElements (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapPriceLimit (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapExMarketDepth (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapExMarketBbo (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapExMarketHistoryKline (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistoryLinearSwapMarkPriceKline (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapExMarketDetailMerged (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapExMarketDetailBatchMerged (params?: {}): Promise<Dict>;
    contractPublicGetV2LinearSwapExMarketDetailBatchMerged (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapExMarketTrade (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapExMarketHistoryTrade (params?: {}): Promise<Dict>;
    contractPublicGetSwapApiV1LinearSwapApiV1SwapInsuranceFund (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapAdjustfactor (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapCrossAdjustfactor (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapHisOpenInterest (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapLadderMargin (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapCrossLadderMargin (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapApiState (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapEliteAccountRatio (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapElitePositionRatio (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapSettlementRecords (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV3SwapLiquidationOrders (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistoryLinearSwapPremiumIndexKline (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistoryLinearSwapEstimatedRateKline (params?: {}): Promise<Dict>;
    contractPublicGetIndexMarketHistoryLinearSwapBasis (params?: {}): Promise<Dict>;
    contractPublicGetLinearSwapApiV1SwapEstimatedSettlementPrice (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketFundingRate (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketFundingRateHistory (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketOpenInterest (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketLiquidationOrders (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketSettlementHistory (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketEliteAccountRatio (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketElitePositionRatio (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketEstimatedSettlementPrice (params?: {}): Promise<Dict>;
    contractPublicGetV5MarketPriceLimit (params?: {}): Promise<Dict>;
    contractPrivateGetApiV1ContractSubAuthList (params?: {}): Promise<Dict>;
    contractPrivateGetApiV1ContractApiTradingStatus (params?: {}): Promise<Dict>;
    contractPrivateGetSwapApiV1SwapSubAuthList (params?: {}): Promise<Dict>;
    contractPrivateGetSwapApiV1SwapApiTradingStatus (params?: {}): Promise<Dict>;
    contractPrivateGetV5AccountAssetMode (params?: {}): Promise<Dict>;
    contractPrivateGetV5AccountBalance (params?: {}): Promise<Dict>;
    contractPrivateGetV5AccountBills (params?: {}): Promise<Dict>;
    contractPrivateGetV5AccountFeeDeductionCurrency (params?: {}): Promise<Dict>;
    contractPrivateGetV5TradePositionOpens (params?: {}): Promise<Dict>;
    contractPrivateGetV5TradeOrderOpens (params?: {}): Promise<Dict>;
    contractPrivateGetV5TradeOrderDetails (params?: {}): Promise<Dict>;
    contractPrivateGetV5TradeOrderHistory (params?: {}): Promise<Dict>;
    contractPrivateGetV5TradeOrder (params?: {}): Promise<Dict>;
    contractPrivateGetV5PositionLever (params?: {}): Promise<Dict>;
    contractPrivateGetV5PositionMode (params?: {}): Promise<Dict>;
    contractPrivateGetV5PositionRiskLimit (params?: {}): Promise<Dict>;
    contractPrivateGetV5PositionRiskLimitTier (params?: {}): Promise<Dict>;
    contractPrivateGetV5MarketRiskLimit (params?: {}): Promise<Dict>;
    contractPrivateGetV5MarketAssetsDeductionCurrency (params?: {}): Promise<Dict>;
    contractPrivateGetV5MarketMultiAssetsMargin (params?: {}): Promise<Dict>;
    contractPrivateGetV5AlgoOrderOpens (params?: {}): Promise<Dict>;
    contractPrivateGetV5AlgoOrder (params?: {}): Promise<Dict>;
    contractPrivateGetV5AlgoOrderHistory (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractBalanceValuation (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractAccountInfo (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractPositionInfo (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractSubAuth (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractSubAccountList (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractSubAccountInfoList (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractSubAccountInfo (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractSubPositionInfo (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractFinancialRecord (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractFinancialRecordExact (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractUserSettlementRecords (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractOrderLimit (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractFee (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTransferLimit (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractPositionLimit (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractAccountPositionInfo (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractMasterSubTransfer (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractMasterSubTransferRecord (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractAvailableLevelRate (params?: {}): Promise<Dict>;
    contractPrivatePostApiV3ContractFinancialRecord (params?: {}): Promise<Dict>;
    contractPrivatePostApiV3ContractFinancialRecordExact (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractCancelAfter (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractOrder (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractBatchorder (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractCancel (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractCancelall (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractSwitchLeverRate (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1LightningClosePosition (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractOrderInfo (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractOrderDetail (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractOpenorders (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractHisordersExact (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractMatchresults (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractMatchresultsExact (params?: {}): Promise<Dict>;
    contractPrivatePostApiV3ContractHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostApiV3ContractHisordersExact (params?: {}): Promise<Dict>;
    contractPrivatePostApiV3ContractMatchresults (params?: {}): Promise<Dict>;
    contractPrivatePostApiV3ContractMatchresultsExact (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTriggerOrder (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTriggerCancel (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTriggerCancelall (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTriggerOpenorders (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTriggerHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTpslOrder (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTpslCancel (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTpslCancelall (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTpslOpenorders (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTpslHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractRelationTpslOrder (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTrackOrder (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTrackCancel (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTrackCancelall (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTrackOpenorders (params?: {}): Promise<Dict>;
    contractPrivatePostApiV1ContractTrackHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapBalanceValuation (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapAccountInfo (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapPositionInfo (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapAccountPositionInfo (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapSubAuth (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapSubAccountList (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapSubAccountInfoList (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapSubAccountInfo (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapSubPositionInfo (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapFinancialRecord (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapFinancialRecordExact (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapUserSettlementRecords (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapAvailableLevelRate (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapOrderLimit (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapFee (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTransferLimit (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapPositionLimit (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapMasterSubTransfer (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapMasterSubTransferRecord (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV3SwapFinancialRecord (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV3SwapFinancialRecordExact (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapCancelAfter (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapOrder (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapBatchorder (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapCancel (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapCancelall (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapLightningClosePosition (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapSwitchLeverRate (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapOrderInfo (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapOrderDetail (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapOpenorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapHisordersExact (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapMatchresults (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapMatchresultsExact (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV3SwapMatchresults (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV3SwapMatchresultsExact (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV3SwapHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV3SwapHisordersExact (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTriggerOrder (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTriggerCancel (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTriggerCancelall (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTriggerOpenorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTriggerHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTpslOrder (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTpslCancel (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTpslCancelall (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTpslOpenorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTpslHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapRelationTpslOrder (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTrackOrder (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTrackCancel (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTrackCancelall (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTrackOpenorders (params?: {}): Promise<Dict>;
    contractPrivatePostSwapApiV1SwapTrackHisorders (params?: {}): Promise<Dict>;
    contractPrivatePostV5AccountAssetMode (params?: {}): Promise<Dict>;
    contractPrivatePostV5TradeOrder (params?: {}): Promise<Dict>;
    contractPrivatePostV5TradeBatchOrders (params?: {}): Promise<Dict>;
    contractPrivatePostV5TradeCancelOrder (params?: {}): Promise<Dict>;
    contractPrivatePostV5TradeCancelBatchOrders (params?: {}): Promise<Dict>;
    contractPrivatePostV5TradeCancelAllOrders (params?: {}): Promise<Dict>;
    contractPrivatePostV5TradeCancelAfter (params?: {}): Promise<Dict>;
    contractPrivatePostV5TradePosition (params?: {}): Promise<Dict>;
    contractPrivatePostV5TradePositionAll (params?: {}): Promise<Dict>;
    contractPrivatePostV5PositionLever (params?: {}): Promise<Dict>;
    contractPrivatePostV5PositionMode (params?: {}): Promise<Dict>;
    contractPrivatePostV5PositionMargin (params?: {}): Promise<Dict>;
    contractPrivatePostV5AccountFeeDeductionCurrency (params?: {}): Promise<Dict>;
    contractPrivatePostV5AlgoOrder (params?: {}): Promise<Dict>;
    contractPrivatePostV5AlgoCancelOrders (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
